class ApiInvestors {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            /**
             * Get all/active investors
             * @return {Object}
             */
            getInvestors(investorFilter) {
                return Restangular.one('investors')
                    .get(investorFilter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all investors with specific selection id
             * @return {Object}
             */
            getInvestorsForSelectionId(selectionId) {
                return Restangular.one('investors/idsForSelection', selectionId)
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all package investors
             * @return {Object}
             */
            getPackageInvestors(filterObj) {
                return Restangular.all('investors')
                    .all('filter')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Email investors
             */
            emailInvestors(filterObj) {
                return Restangular.all('investors')
                    .all('export')
                    .all('email')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all team (custom) investors
             * @return {Object}
             */
            getTeamInvestors(filterObj) {
                return Restangular.all('investors')
                    .all('customerInvestors')
                    .all('filter')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all subtypes from active investors
             */
            getInvestorsSubtypes(filter) {
                return Restangular.one('investors/subtypes')
                    .get(filter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get all/active investors
             * @return {Object}
             */
            getDetailedInvestors(investorFilter) {
                return Restangular.one('investors/detailed')
                    .get(investorFilter)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            /**
             * Get contact by Id
             * @return {Object}
             */
            getInvestor(investorId, param) {
                return Restangular.one('investors', investorId)
                    .get(param)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            postInvestor(investor) {
                return Restangular.all('investors')
                    .post(investor)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            putInvestor(investor) {
                return Restangular.one('investors', investor.investorId)
                    .customPUT(investor)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteInvestor(investorId) {
                return Restangular.one('investors', investorId)
                    .remove()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            checkAccountAccess(userId, investorId, isCustomerInvestor) {
                return Restangular.one('investors/checkUserAccess')
                    .get({
                        userId: userId,
                        investorId: investorId,
                        isCustomerInvestor: isCustomerInvestor,
                    })
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getPackageInvestorsCount(filterObj) {
                return Restangular.all('investors')
                    .all('count')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getTeamInvestorsCount(filterObj) {
                return Restangular.all('investors')
                    .all('customerInvestors')
                    .all('count')
                    .post(filterObj)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
            putAdditionalInfo(additionalInfo) {
                return Restangular.one('investors')
                    .one('additionalInfo')
                    .customPUT(additionalInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
            postAdditionalInfo(additionalInfo) {
                return Restangular.one('investors/additionalInfo')
                    .customPOST(additionalInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
            putAllocationInfo(allocationInfo) {
                return Restangular.one('investors')
                    .one('assetAllocation/additionalInfo')
                    .customPUT(allocationInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },
            postAllocationInfo(allocationInfo) {
                return Restangular.one(
                    'investors/assetAllocation/additionalInfo'
                )
                    .customPOST(allocationInfo)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            postSavedSearch(savedSearch) {
                return Restangular.one('investors')
                    .one('filter/saved')
                    .customPOST(savedSearch)
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            getSavedSearch() {
                return Restangular.one('investors')
                    .one('filter/saved')
                    .get()
                    .then(
                        ApiBaseResponseService.onSuccess,
                        ApiBaseResponseService.onError
                    );
            },

            deleteSavedSearch(name) {
                Restangular.one('investors')
                    .one('filter/saved')
                    .one(encodeURIComponent(name))
                    .remove();
            },
        };
    }
}

ApiInvestors.inject = ['Restangular', 'ApiBaseResponseService'];

export default ApiInvestors;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiInvestors.js
 **/